/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PERIODS, GET_PERIODS } from 'src/actions/periodActions';

const initialState = {
  items: [],
  isFetching: false,
  message: ''
};

const periodReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PERIODS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PERIODS: {
      const { periods, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = periods;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default periodReducer;
